import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useUpdatePlaylistContentDeprecated, useAddPlaylistSection } from 'actions/playlists';
import SectionEditorModalUi from './SectionEditorModalUi';
function SectionEditorModal(_ref) {
  var section = _ref.section,
    playlistId = _ref.playlistId,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var editMode = !!section;
  var _useUpdatePlaylistCon = useUpdatePlaylistContentDeprecated(playlistId, {
      successMessage: t('alert_section_updated_successfully'),
      errorMessage: t('alert_section_not_updated')
    }),
    updatePlaylistContent = _useUpdatePlaylistCon.updatePlaylistContent,
    isUpdating = _useUpdatePlaylistCon.isLoading;
  var _useAddPlaylistSectio = useAddPlaylistSection(playlistId),
    addPlaylistSection = _useAddPlaylistSectio.addPlaylistSection,
    isCreating = _useAddPlaylistSectio.isLoading;
  function submit(_x) {
    return _submit.apply(this, arguments);
  }
  function _submit() {
    _submit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var name, description;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            name = _ref2.name, description = _ref2.description;
            if (!editMode) {
              _context.next = 6;
              break;
            }
            _context.next = 4;
            return updatePlaylistContent([{
              contentId: section.id,
              name: name,
              description: description
            }]);
          case 4:
            _context.next = 8;
            break;
          case 6:
            _context.next = 8;
            return addPlaylistSection({
              name: name,
              description: description
            });
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _submit.apply(this, arguments);
  }
  return /*#__PURE__*/React.createElement(SectionEditorModalUi, {
    initialSectionData: section,
    isSaving: isUpdating || isCreating,
    onSubmit: submit,
    onClose: onClose
  });
}
export { SectionEditorModalUi };
export default SectionEditorModal;